import {Breadcrumbs, ErrorPopup, Notice, Title} from '@management-ui/core';
import {reverse} from 'named-urls';
import React from 'react';
import routes from '../../../../routes';


const Wrapper = ({title, loading, titleControls, contact, crumbs, errors, children}) => {
  return (
    <>
      <Breadcrumbs crumbs={crumbs}/>
      <Title title={title} loading={loading} controls={titleControls}/>
      <Notice
        display={contact && contact.archived}
        message={[
          'This contact has been archived and is therefore no longer available.',
          'You won\'t be able to modify it unless it is restored.'
        ].join(' ')}
      />
      {children}
      <ErrorPopup errors={['contact']} messages={errors}/>
    </>
  );
}

Wrapper.standardCrumbs = [
  {title: 'Contacts', link: routes.contacts.index}
];
Wrapper.archiveCrumbs = [
  {title: 'Archive', link: reverse(routes.archive.index)},
  {title: 'Contacts', link: reverse(routes.archive.index, {tab: 'contacts'})}
];

export default Wrapper;
